import { useBookmarkSelection } from '../../contexts/BookmarkSelectionContext';
import BookmarkBatchOperations from './BookmarkBatchOperations';
import type { ViewMode } from '../../types/api';
import type { PageInfo } from '../../utils/pageInfo';
import type { BookmarkListBatchMeta } from './types';

export interface BatchOperationsBarProps {
  viewMode?: ViewMode;
  pageInfo?: PageInfo | null;
  bookmarkListBatchMeta?: BookmarkListBatchMeta | null;
}

function BatchOperationsBar({
  viewMode = 'unread',
  pageInfo = null,
  bookmarkListBatchMeta = null,
}: BatchOperationsBarProps) {
  const { isBatchMode } = useBookmarkSelection();

  // Mobile batch toolbar deferred until mobile can enter batch mode.
  if (!isBatchMode) {
    return null;
  }

  return (
    <div className="hidden w-full max-w-xl md:block">
      <BookmarkBatchOperations
        viewMode={viewMode}
        pageInfo={pageInfo}
        bookmarkListBatchMeta={bookmarkListBatchMeta}
      />
    </div>
  );
}

export default BatchOperationsBar;
